import gql from 'graphql-tag'
import { PageInfoFragment } from '@/graphql/mia/fragments/pageInfo'
import { ReadErrorFragment } from '@/graphql/mia/fragments/readError'
import { ChatPromptTranslateFragment } from '@/graphql/mia/fragments/chatPromptTranslate'

export const READ_CHAT_PROMPT_TRANSLATE = gql`
  query ReadChatPromptTranslate($chatPromptTranslateInput: ChatPromptTranslateInput!) {
    readChatPromptTranslate(chatPromptTranslateInput: $chatPromptTranslateInput) {
      data {
        ...ChatPromptTranslateFragment
      }
      error {
        ...ReadErrorFragment
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
  ${PageInfoFragment}
  ${ReadErrorFragment}
  ${ChatPromptTranslateFragment}
`
